if (!customElements.get('recently-viewed-products')) {
  customElements.define(
    'recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest('[data-recently-viewed-section]');
      }

      connectedCallback() {
        const currentProduct = this.dataset.handle;
        const max = parseInt(this.dataset.max) || 20;

        // Use the new RecentlyViewedProducts class
        this.productsToShow = window.recentlyViewedProducts.getRecentProducts({
          limit: max,
          excludeHandle: currentProduct,
        });

        if (this.productsToShow.length > 0) {
          this.loadProducts();
        } else {
          this.section.classList.add('hidden');
        }
      }

      loadProducts() {
        if (this.productsToShow.length === 0) {
          this.section.classList.add('hidden');
          return;
        }

        // Create a search query with all product handles
        const searchQuery = this.productsToShow.map((handle) => `handle:${handle}`).join(' OR ');
        fetch(
          `${Shopify.routes.root}search?q=${encodeURIComponent(searchQuery)}&type=product&section_id=${
            this.dataset.sectionId
          }`
        )
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recentlyViewedProducts = html.querySelector('recently-viewed-products');

            if (recentlyViewedProducts?.innerHTML.trim().length) {
              this.innerHTML = recentlyViewedProducts.innerHTML;
              this.section.classList.remove('hidden');
            } else {
              this.section.classList.add('hidden');
            }
          })
          .catch((error) => {
            console.error(error);
            this.section.classList.add('hidden');
          });
      }
    }
  );
}
